import type { SequenceTriggerEvent } from '@/types/custom-playbooks';

/**
 * What can start a play from a sequence, in the order the trigger lists
 * them. `word` is the short form the node summary uses.
 */
export const SEQUENCE_EVENT_OPTIONS: readonly {
  value: SequenceTriggerEvent;
  label: string;
  word: string;
}[] = [
  { value: 'replied', label: 'Someone replies', word: 'Replies' },
  { value: 'finished', label: 'Someone finishes', word: 'Finishes' },
  {
    value: 'finished_no_reply',
    label: 'Finishes with no reply',
    word: 'Finishes with no reply',
  },
  { value: 'bounced', label: 'Email bounces', word: 'Bounces' },
  { value: 'out_of_office', label: 'Out of office', word: 'Out of office' },
  { value: 'meeting_booked', label: 'Meeting booked', word: 'Meeting booked' },
  {
    value: 'invite_accepted',
    label: 'Invite accepted',
    word: 'Invite accepted',
  },
  { value: 'call_outcome', label: 'Call outcome', word: 'Call outcome' },
  { value: 'link_clicked', label: 'Link clicked', word: 'Link clicked' },
  {
    value: 'left_company',
    label: 'Left the company',
    word: 'Left the company',
  },
  {
    value: 'step_reached',
    label: 'Reaches a play step',
    word: 'Reaches a play step',
  },
];
